module.exports = __webpack_public_path__ + "static/media/29ADMSPC40.47cf08ba.jpg";